import { ButtonBase, FormHelperText, Grid } from "@mui/material";
import UploadProductImagesNew from "../../components/Form/UploadProductImagesNew";
import CustomTextField from "../../components/Form/CustomTextField";
import ThumbnailUploader from "../../components/Form/ThumbnailUploader";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function ProfileInfoForm({ formObj, handleFormChange, setNotification, error, layoutWidth }) {
    return (
        <Grid container spacing={1}>
            <Grid item sm={12}>
                <div className="text-semibold">Dealer Logo</div>
                <div className="subheader-2">Add an image or logo that represents your company</div>
            </Grid>
            <Grid item sm={12} xs={12}>
                <ThumbnailUploader
                    value={formObj?.logo_images}
                    onChange={(e) => handleFormChange('logo_images', e)}
                />
                {error?.logo_images && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error.logo_images || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} mt={2}>
                <div className="text-semibold">Banner Image</div>
                <div className="subheader-2">Recommended size: 1440px x 320px</div>
            </Grid>
            <Grid item sm={12} xs={12}>
                <UploadProductImagesNew
                    showLimit={false}
                    displayFiles={false}
                    values={formObj?.banner_images}
                    setFormValues={(e) => handleFormChange('banner_images', e)}
                    maxFile={1}
                    multiple={true}
                    setNotification={setNotification}
                    images={true}
                    windowWidth={layoutWidth}
                />
                {error?.banner_images && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error.banner_images || ""}</FormHelperText>}
            </Grid>
            {/* <Grid item sm={12}>
                <div className="text-semibold">About Dealer</div>
                <div className="subheader-2">Tell us a little bit about the business.</div>
            </Grid>
            <Grid item sm={12} xs={12}>
                <CustomTextField
                    values={formObj?.dealer_description}
                    placeholder={'Short business description'}
                    onChange={(e) => {
                        const value = e;
                        if (value.length <= 250) {
                            handleFormChange('dealer_description', e)
                        }
                    }}
                    multiline={true}
                    rows={6}
                    width={'100%'}
                    error={error?.dealer_description}
                    subtitle={`${formObj?.dealer_description ? formObj?.dealer_description?.length : 0}/250`}
                />
            </Grid> */}
        </Grid>
    )
}